module.exports = __webpack_public_path__ + "img/5_93.098390e2.png";